import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexUnjustifiedAbsencesRequest = ({ dispatch, params = {}, successCallback, failureCallback }) => {
  ApiService.request('get', '/unjustified_absences', {
    dispatch,
    params,
    successCallback,
    failureCallback
  });
};

export const showUnjustifiedAbsenceRequest = (id, { dispatch, successCallback, failureCallback }) => {
  ApiService.request('get', `/unjustified_absences/${id}`, {
    dispatch,
    successCallback,
    failureCallback
  });
};

export const createUnjustifiedAbsenceRequest = ({ dispatch, params, successCallback, failureCallback }) => {
  ApiService.request('post', '/unjustified_absences', {
    dispatch,
    params,
    formData: true,
    failureCallback,
    successCallback
  });
};

export const updateUnjustifiedAbsenceRequest = (
  id,
  { dispatch, params, formData = false, successCallback, failureCallback }
) => {
  ApiService.request('put', `/unjustified_absences/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });
};

export const deleteUnjustifiedAbsenceRequest = (id, { dispatch, successCallback, failureCallback }) => {
  ApiService.request('delete', `/unjustified_absences/${id}`, {
    dispatch,
    successCallback,
    failureCallback
  });
};

export const exportUnjustifiedAbsencesRequest = ({ dispatch, params = {}, failureCallback, successCallback }) => {
  ApiService.request('get', `/unjustified_absences/export.xlsx`, {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback
  });
};

export const importTemplateUnjustifiedAbsenceRequest = ({ dispatch, params, failureCallback, successCallback }) => {
  ApiService.request('get', '/unjustified_absences/import_template', {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback
  });
};

export const preImportUnjustifiedAbsenceRequest = ({
  dispatch,
  params,
  formData,
  failureCallback,
  successCallback
}) => {
  ApiService.request('get', '/unjustified_absences/pre_import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importUnjustifiedAbsenceRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/unjustified_absences/import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const createMassiveUnjustifiedAbsenceRequest = ({
  dispatch,
  params,
  formData,
  successCallback,
  failureCallback
}) => {
  ApiService.request('post', '/unjustified_absences/massive_create', {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });
};

export const debounceIndexUnjustifiedAbsencesRequest = AwesomeDebouncePromise(indexUnjustifiedAbsencesRequest, 300);
